import styled from "styled-components";
import { Heading1, SubHeading } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import { breakpoints, device } from "../../../utils/responsive_utilities";
import { white, royal, codGrey } from '../../../components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../../landing-pages/js/common/mixins/mixin';

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${white};
  ${styledFont("Graphie")}
  padding: 3rem 1.6rem;
  box-sizing: border-box;
  display: flex;
  /* flex-wrap: wrap; */
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  @media ${device.Desktop}{
    padding: 16.8rem 13rem 12.6rem 1.6rem;
    flex-direction: row-reverse;
  }
  @media ${device.TabletLandscape}{
    flex-direction: row-reverse;
  }
`;

export const FeaturesWrapper = styled.div`
  display: flex;
  width: 33.9rem;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  align-items: flex-start;
  margin: auto;
  @media ${device.TabletLandscape}, ${device.Desktop} {
    /* flex: 1; */
    width: 34.6rem;
    align-items: flex-start;
  }

  @media ${device.Tablet}, ${device.PhoneTabletLandscape}{
    width: 36.4rem;
  }
`;
export const HeadingText = styled.h2`
  width: auto;
  color: ${codGrey};
  padding-top: 3rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)};
  text-align: left;
  margin: 0;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 4, 4.8, 7)};
    width: 80%;
  }
`;

export const SubHeadingText = styled(SubHeading)`
  width: 100%;
  color: ${royal};
  padding-top: 0.5rem;
  ${styledFont("Graphie", 2, 2.4, 6)}
  text-align: left;
  @media (min-width: ${breakpoints.sm}px) {
    width: auto;
  }
  @media (min-width: ${breakpoints.md}px) {
    width: auto;
  }
`;

export const ListWrapper = styled.ul`
  padding: 0 0 2.8rem;
  width: auto;
  list-style: none;
  margin: 0;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: baseline;
  ${styledFont("Graphie", 1.8, 2, 4)};
  color: ${props=>props.fColor || white};
  margin-top: 1.5rem;

  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 2, 2.4, 4)};
  }
  &:before {
    content: ' ';
    width: 1rem;
    height: 1rem;
    background-color: ${props=>props.bulletColor || white};
    display: inline-flex;
    margin-right: 1.2rem;
    border-radius: 50%;
    flex-shrink: 0;
    @media (min-width: ${breakpoints.lg}px) {
      width: 1.2rem;
      height: 1.2rem;

    }
  }
`;

export const ImageContainer = styled.div`
  /* width: 100%; */
  margin-top: 6.3rem;

  @media ${device.Desktop}, ${device.TabletLandscape}{
    margin-top: 0;
  }
  @media ${device.Tablet}{
    margin-top: 6.3rem;
  }
  @media ${device.PhoneTabletLandscape}{
    margin-top: 3.7rem;
  }
`

export const ImacSectionWrapper = styled.div`
  width: 37.2rem;
  height: 25.9rem;
  > img {
    width: 100%;
    height: 100%;
    margin-left: -1.6rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    flex: 2;
    margin-right: 6rem;
    width: 86.1rem;
    height: 55rem;
  }
  @media ${device.TabletLandscape}{
    width: 59.9rem;
    height: 38.3rem;
    margin-right: 0rem; 
  }
  @media ${device.Tablet}{
    width: 76.6rem;
    height: 49.4rem;
  }

  @media ${device.PhoneTabletLandscape}{
    width: 100%;
    height: 100%;
  }
`;

export const AppDownloads = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  > img {
    width: 16.4rem;
  }
  > p {
    ${styledFont("Graphie", 1.1, 1.3, 4)}
    margin-bottom: 1.2rem;
    text-align: center;
  }
  @media (min-width: ${breakpoints.sm}px) {
    width: 28rem;
    margin: 0 auto;
  }
  @media (min-width: ${breakpoints.md}px) {
    /* width: 26rem; */
    margin: -4rem auto 0;
    > img {
      width: 12.3rem;
    }
  }
`;

export const IconsContainer = styled.div`
  margin: auto;
  >img{
    width: 12.3rem;
    margin-right: 1.6rem;
  }
`

export const ButtonWrapper = styled.div`
  width: 100%;
  >div{
    width: 25.2rem;
    margin: auto;

    @media ${device.Desktop}, ${device.TabletLandscape}{
      margin: 0;
    }
  }
`
